module.exports = __webpack_public_path__ + "img/ok.ad3ce48d.png";